import * as React from 'react';
import * as style from './style.css';
import { Responsive, UIText1, UIText2 } from '@cian/ui-kit';
import { IRegion } from '../../types/regions';
import { clsx } from 'clsx';

interface IRegionChipsProps {
  regions: IRegion[];
  currentRegionId?: number;
}

export const RegionChips = ({ regions, currentRegionId }: IRegionChipsProps) => {
  return (
    <div data-testid="RegionChips" className={style['container']}>
      <UIText1>Регионы работы:</UIText1>
      <div className={style['items']}>
        {regions.map(region => (
          <a
            key={region.id}
            href={`${region.developerCardUrl}#projects`}
            className={clsx(style['link'], region.id === currentRegionId && style['link--active'])}
          >
            <Responsive desktop>
              <UIText2>{region.name}</UIText2>
            </Responsive>
            <Responsive phone tablet>
              <UIText1>{region.name}</UIText1>
            </Responsive>
          </a>
        ))}
      </div>
    </div>
  );
};
